'use strict';
var camelCase = require('camelcase');

module.exports = function () {
	var cased = camelCase.apply(camelCase, arguments);
	return cased.charAt(0).toUpperCase() + cased.slice(1);
};



//////////////////
// WEBPACK FOOTER
// ./~/uppercamelcase/index.js
// module id = 1171
// module chunks = 0